<template>
  <v-list-item
    @click="handleClick"
    :active="active"
    :active-class="activeClasses"
    :class="[{ rail }, { 'py-6': large }]"
    :to="action ? undefined : { name: route, params: params, query: query }"
    class="hover-td-none-deep"
  >
    <v-list-item-title class="d-flex align-center">
      <v-tooltip
        :disabled="!showRailTooltip"
        location="end"
      >
        <template #activator="{ props: tooltipProps }">
          <span
            class="d-flex align-center min-w-0"
            v-bind="tooltipProps"
          >
            <v-icon
              v-if="icon"
              :aria-label="$bct(title)"
              :class="{ 'me-3': !rail }"
              :icon="icon"
              active-class="c-primary"
              class="material-icons-outlined"
              size="22"
            />

            <span
              v-if="!rail"
              class="fs-16 fw-500"
            >
              {{ $bct(title) }}
            </span>

            <v-icon
              v-if="nestedNav"
              class="material-icons-outlined"
              icon="chevron_right"
            />
          </span>
        </template>
        <span>{{ $bct(title) }}</span>
      </v-tooltip>
    </v-list-item-title>
  </v-list-item>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import vuetify from '@/plugins/vuetify';

const vueRoute = useRoute();
const store = useStore();

const $bct = inject('translator');

const props = defineProps({
  action: {
    type: Function,
    default: null,
  },
  activeRouteRoot: {
    type: String,
    default: undefined,
  },
  icon: {
    type: String,
    default: null,
  },
  large: {
    type: Boolean,
    default: false,
  },
  nestedNav: {
    type: Boolean,
    default: false,
  },
  params: {
    type: Object,
    default: undefined,
  },
  query: {
    type: Object,
    default: undefined,
  },
  route: {
    type: String,
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
});

const active = computed(() => {
  if (!props.activeRouteRoot) return undefined;

  return vueRoute.path.includes(props.activeRouteRoot) || undefined;
});

const activeClasses = computed(() => {
  if (store.state.site?.enable_provider_v2) return '';
  return 'bg-white c-primary fw-600';
});

const rail = computed(() => {
  return store.state.miniNav && !vuetify.display.mobile.value;
});

const showRailTooltip = computed(() => {
  return rail.value && props.title != null && props.title !== '';
});

function handleClick() {
  if (props.action) props.action();
}
</script>
